export default {
  namespaced: true,
  state: {
    isUpdatePopupActive: false,
    content: '',
    title: '',
  },
  mutations: {
    OPEN_UPDATEPOPUP(state, data) {
      state.isUpdatePopupActive = true;
      state.content = data.content;
      state.title = data.title;
    },
    CLOSE_UPDATEPOPUP(state) {
      state.isUpdatePopupActive = false;
    },
  },
  actions: {
    openUpdatePopup({ commit }, data) {
      commit('OPEN_UPDATEPOPUP', data);
    },
    closeUpdatePopup({ commit }, data) {
      commit('CLOSE_UPDATEPOPUP', data);
    },
  },
};
